import React, { useState } from "react";

import {
  Box,
  Flex,
  IconOnePassFlybuys,
  NotificationBadge,
} from "@catchoftheday/cg-components";
import { useTheme } from "@catchoftheday/theme";

import {
  HeaderTile,
  HeaderTileRenderProps,
} from "@header/components/HeaderTile";
import { SpanWithAfterDownArrow } from "@header/components/SpanWithAfterDownArrow";
import { sessionStorage } from "@header/utilities/index";

import flybuysTheme from "../../flybuysTheme";
import { HeaderTileContainer } from "../HeaderTileContainer";

import { PopupContent } from "./PopupContent";

const SESSION_STORAGE_KEY = "CCFlyBuysTileHover";

export type OnePassFlybuysTileProps = {};

export const OnePassFlybuysTile: React.FC<OnePassFlybuysTileProps> = () => {
  const theme = useTheme();

  const CCFlyBuysTileHoverSessionStorage =
    sessionStorage?.getItem(SESSION_STORAGE_KEY) != "true";
  const [ccFlybuysNew, setCcFlybuysNew] = useState(true);

  const renderIcon: HeaderTileRenderProps = ({ isOpen }) => {
    const iconStyleOnHover = {
      svg: {
        ".onepass": {
          fill: theme?.colors?.["onePass"]?.["primary"],
        },
        ".x-mark": {
          fill: theme?.colors?.brand?.primary,
        },
      },
    };

    const iconStyle = {
      "&:hover": iconStyleOnHover,
      svg: isOpen ? iconStyleOnHover.svg : undefined,
      ".flybuys": isOpen
        ? {
            fill: flybuysTheme.bgColor,
          }
        : undefined,
    };

    return (
      <HeaderTileContainer
        data-testid="cc-flybuys-icon"
        hasRightBorder
        flexProps={{
          px: "0.875rem",
        }}
        linkProps={{
          css: iconStyle,
          backgroundColor: isOpen ? "white" : undefined,
          color: isOpen ? "secondaryDark" : "white",
          "aria-label": "OnePass and flybuys",
          href: "/onepass",
          onMouseEnter: () => {
            setCcFlybuysNew(false);
          },
          className: "js-dnt",
          "data-tracking": "header-app-onepass",
        }}
      >
        <Flex flexDirection="column" alignItems="center">
          <Box position="relative">
            {CCFlyBuysTileHoverSessionStorage && ccFlybuysNew && (
              <NotificationBadge
                text={"1"}
                data-testid="onepass-flybuys-new"
                absRight="-18px"
              />
            )}
            <IconOnePassFlybuys
              width={"66px"}
              height={"auto"}
              title="OnePass and Flybuys"
            />
          </Box>
          <SpanWithAfterDownArrow>$2 = 2 points*</SpanWithAfterDownArrow>
        </Flex>
      </HeaderTileContainer>
    );
  };

  return (
    <HeaderTile
      popoverProps={{
        placement: "bottom",
      }}
      icon={renderIcon}
      onTileShow={(isOpen) => {
        if (isOpen) {
          sessionStorage?.setItem(SESSION_STORAGE_KEY, "true");
          setCcFlybuysNew(false);
        }
      }}
    >
      <PopupContent />
    </HeaderTile>
  );
};
